import styled, { css } from 'styled-components'
import { rem } from 'polished'
import * as React from 'react'
import focusStyle from 'styles/utils/focusStyle'

const thumbStyle = css`
  appearance: none;
  pointer-events: auto;
  height: ${rem(24)};
  width: ${rem(24)};
  border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  border-radius: ${props => props.theme.borderRadius.round};
  transition: background-color 0.2s;
`

const thumbHoverActiveSTyle = css`
  background-color: ${props => props.theme.palette.neutral.surface.lightBackground};
`

const Range = styled.input`
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  appearance: none;
  background-color: transparent;
  pointer-events: none;
  margin: 0;

  &::-webkit-slider-thumb {
    ${thumbStyle}
  }

  &::-moz-range-thumb {
    ${thumbStyle}
  }

  &::-ms-thumb {
    ${thumbStyle}
  }

  &:focus-visible {
    &::-webkit-slider-thumb {
      ${focusStyle}
    }

    &::-moz-range-thumb {
      ${focusStyle}
    }

    &::-ms-thumb {
      ${focusStyle}
    }
  }

  &:hover, &:active {
    &::-webkit-slider-thumb {
      ${thumbHoverActiveSTyle}
    }

    &::-moz-range-thumb {
      ${thumbHoverActiveSTyle}
    }

    &::-ms-thumb {
      ${thumbHoverActiveSTyle}
    }
  }
`

interface Props extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  ref?: React.RefObject<HTMLInputElement | null>
}

function RangeInput(props: Props) {
  return <Range {...props} type="range" />
}

export default RangeInput
